<template>
  <div>
    <top-navbar></top-navbar>
    <div class="mb-5 background_color">
      <h6 class="manage-boder pt-2 font1 decoration">
        <router-link class="decoration" to="/">Home</router-link>
        <span class="pfimg3"><i class="fa fa-angle-right" aria-hidden="true"></i></span>
        <a class="decoration">Rental</a>
        <span class="pfimg3"><i class="fa fa-angle-right" aria-hidden="true"></i></span>
        Rental Return List
      </h6>

      <div style="padding-bottom: 120px;" class="container-fluid">
        <div style="border: 0; padding: 0; min-height: 0;" class="navbar background_color">
          <div class="d-flex flex-column flex-md-row flex-wrap gap-2">
            <b-input-group size="sm" class="w-100" style="max-width: 225px;">
              <b-form-input v-model="filter" @input="loadReturns()" type="search" placeholder="Search" />
            </b-input-group>
            <div class="ms-md-2 mt-2 mt-md-0">
              <span class="custom-breadcrumb d-block text-center text-md-start">
                <b>Showing {{ rangeStart }} - {{ rangeEnd }} of {{ totalRows }} items.</b>
              </span>
            </div>
          </div>
          <button @click="createReturn()" class="btn btn-outline-primary btn-sm mb-1 mt-1 bdr-rad">
            Create Rental GRN
          </button>
        </div>

        <div class="card bdr-rad2 mt-1 shadow p-2">
          <div class="card-body">
            <div class="d-flex justify-content-center" v-if="isLoading">
              <div class="spinner-border text-primary" role="status">
                <span class="visually-hidden">Loading...</span>
              </div>
            </div>

            <div v-else class="table-responsive">
              <b-table responsive style="font-size: small;" class="table-hover" :items="allDatas" :fields="fields" show-empty small>
                <template #cell(number)="row">
                  {{ (currentPage - 1) * perPage + row.index + 1 }}
                </template>
                <template #cell(actions)="row">
                  <div class="dropdown">
                    <button class="btn btn-sm btn-outline-primary dropdown-toggle bdr-rad" type="button" data-toggle="dropdown" aria-expanded="false">
                      Action
                    </button>
                    <div class="dropdown-menu bdr-rad">
                      <a class="dropdown-item mouse-cursor" @click="viewReturn(row.item)">View</a>
                      <a class="dropdown-item mouse-cursor" v-show="row.item.statusvalue == 1" @click="confirmReturn(row.item.id)">Confirm</a>
                      <a class="dropdown-item mouse-cursor" @click="viewGin(row.item.rental_gin_id)">View Rental GIN</a>
                    </div>
                  </div>
                </template>
              </b-table>

              <b-pagination v-model="currentPage" pills :total-rows="totalRows" :per-page="perPage" size="sm" @input="loadReturns()" />
            </div>
          </div>
        </div>

        <b-modal :id="infoModal.id" :title="infoModal.title" size="lg" hide-footer>
          <table style="font-size: small;" class="table table-sm">
            <tbody>
              <tr><td><b>Rental GRN</b></td><td>{{ infoModal.content.grn_no }}</td></tr>
              <tr><td><b>Rental GIN</b></td><td>{{ infoModal.content.gin_no }}</td></tr>
              <tr><td><b>GRN Date</b></td><td>{{ infoModal.content.grn_date }}</td></tr>
              <tr><td><b>Customer</b></td><td>{{ infoModal.content.customer_name }}</td></tr>
              <tr><td><b>Remarks</b></td><td>{{ infoModal.content.remarks }}</td></tr>
            </tbody>
          </table>
          <table style="font-size: small;" class="table table-sm table-hover">
            <thead class="background_color2">
              <tr>
                <th>Model</th>
                <th>Engine No.</th>
                <th>Chassis No.</th>
                <th>Return Date</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="detail in infoModal.details" :key="detail.id">
                <td>{{ detail.model_name }}</td>
                <td>{{ detail.engine_no }}</td>
                <td>{{ detail.chassis_no }}</td>
                <td>{{ detail.return_date }}</td>
              </tr>
            </tbody>
          </table>
        </b-modal>
      </div>
    </div>
    <content-footer></content-footer>
  </div>
</template>

<script>
import axios from "axios";
import authService from "@/auth.service";
import TopNavbar from "./../../layout/TopNavbar.vue";
import ContentFooter from "./../../layout/ContentFooter.vue";

export default {
  name: "RentalReturnIndex",
  components: { TopNavbar, ContentFooter },
  data() {
    return {
      accessToken: authService.isLoggedIn(),
      userid: authService.isUserid(),
      allDatas: [],
      filter: "",
      totalRows: 0,
      currentPage: 1,
      perPage: 15,
      isLoading: true,
      fields: [
        { key: "number", label: "#", sortable: true },
        { key: "grn_no", label: "Rental GRN No.", sortable: true },
        { key: "grn_date", label: "GRN Date", sortable: true },
        { key: "gin_no", label: "Rental GIN No.", sortable: true },
        { key: "customer_name", label: "Customer", sortable: true },
        { key: "unit_count", label: "Units", sortable: true, class: "text_right" },
        { key: "status", label: "Status", sortable: true },
        { key: "actions", label: "Actions", class: "width-custom7" },
      ],
      infoModal: {
        id: "rental-return-info-modal",
        title: "",
        content: {},
        details: [],
      },
    };
  },
  computed: {
    rangeStart() {
      return this.totalRows ? (this.currentPage - 1) * this.perPage + 1 : 0;
    },
    rangeEnd() {
      return Math.min(this.currentPage * this.perPage, this.totalRows);
    },
  },
  mounted() {
    this.loadReturns();
  },
  methods: {
    headers() {
      return {
        Authorization: "Bearer " + this.accessToken,
        "Content-type": "application/json",
      };
    },
    async loadReturns() {
      this.isLoading = true;
      try {
        const { data } = await axios.get("/rentalgin/returnlist", {
          params: {
            page: this.currentPage,
            perPage: this.perPage,
            filter: this.filter || "",
          },
          headers: this.headers(),
        });
        this.allDatas = data.all_data || [];
        this.totalRows = data.total_count || this.allDatas.length || 0;
      } catch (error) {
        console.log(error.response || error);
        this.allDatas = [];
        this.totalRows = 0;
      } finally {
        this.isLoading = false;
      }
    },
    createReturn() {
      this.$router.push("/rental/grn/create");
    },
    viewGin(id) {
      this.$router.push("/rental/gin?id=" + id);
    },
    async viewReturn(item) {
      try {
        const { data } = await axios.get("/rentalgin/returnview?id=" + item.id, {
          headers: this.headers(),
        });
        if (data.status === 1) {
          this.infoModal.title = data.grn.grn_no;
          this.infoModal.content = data.grn;
          this.infoModal.details = data.details || [];
          this.$bvModal.show(this.infoModal.id);
        }
      } catch (error) {
        console.log(error.response || error);
      }
    },
    async confirmReturn(id) {
      if (!confirm("Are you sure you want to confirm this Rental Return?")) {
        return;
      }

      try {
        const { data } = await axios.post("/rentalgin/confirmreturn?id=" + id, {
          userid: this.userid,
        }, {
          headers: this.headers(),
        });

        if (data.status === 200) {
          this.loadReturns();
        } else if (data.message) {
          alert(data.message);
        }
      } catch (error) {
        console.log(error.response || error);
      }
    },
  },
};
</script>
